import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { PageTitle } from 'components/shared/page_title';
import DataConfirmation from 'components/shared/data_confirmation';
import DocumentComponent from 'components/shared/document_component';

interface ViewComplianceTermProps {
    values: {
        termo_escolar_pmaf_elaborado: boolean;
        termo_escolar_pmaf_validado_seaf_mt: boolean;
        termo_escolar_ato_normativo_publicado: boolean;
        termo_escolar_ato_normativo_uuid?: string | null;
        termo_escolar_cmdrs_constituido: boolean;
        termo_escolar_atas_reunioes_uuid?: string | null;
    };
}

const ViewComplianceTerm: React.FC<ViewComplianceTermProps> = ({ values }) => {
    return (
        <>
            <PageTitle
                title="Cumprimento do Termo Escolar"
                subtitle="Visualização dos dados informados sobre o cumprimento dos requisitos do Termo de Adesão pelo Município."
            />

            <Stack marginX="4rem" spacing="2rem" maxWidth="1152px" width="100%">
                <DataConfirmation
                    title="Respostas"
                    data={[
                        {
                            label: 'Elaboração do PMAF',
                            value: values.termo_escolar_pmaf_elaborado ? 'Sim' : 'Não',
                        },
                        {
                            label: 'Validação pela SEAF',
                            value: values.termo_escolar_pmaf_validado_seaf_mt ? 'Sim' : 'Não',
                        },
                        {
                            label: 'Existência de ato normativo',
                            value: values.termo_escolar_ato_normativo_publicado ? 'Sim' : 'Não',
                        },
                        {
                            label: 'Existência de CMDRS via Lei',
                            value: values.termo_escolar_cmdrs_constituido ? 'Sim' : 'Não',
                        },
                    ]}
                />

                {values.termo_escolar_ato_normativo_publicado && values.termo_escolar_ato_normativo_uuid && (
                    <Box>
                        <Typography fontWeight={600} mb={1}>
                            Ato Normativo (PDF)
                        </Typography>
                        <DocumentComponent
                            uuid={values.termo_escolar_ato_normativo_uuid}
                            podeEnviar={false}
                        />
                    </Box>
                )}

                {values.termo_escolar_cmdrs_constituido && values.termo_escolar_atas_reunioes_uuid && (
                    <Box>
                        <Typography fontWeight={600} mb={1}>
                            Atas do CMDRS (mínimo de 4) (PDF)
                        </Typography>
                        <DocumentComponent
                            uuid={values.termo_escolar_atas_reunioes_uuid}
                            podeEnviar={false}
                        />
                    </Box>
                )}
            </Stack>
        </>
    );
};

export default ViewComplianceTerm;